import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { InitialState, CourseType } from './types'
import { useAlert } from 'react-alert'
import { Link } from 'react-router-dom'
import * as actions from './actions'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'

export default () => {
  const dispatch = useDispatch()
  const alert = useAlert()

  useEffect(() => {
    dispatch(actions.fetchCoursesList())
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  const { courses, isFetching, error } = useSelector(
    (state: { adminCoursesList: InitialState }) => state.adminCoursesList
  )

  useEffect(() => {
    if (error) {
      alert.error(error)
    }
  }, [error])

  const CourseItem = ({ item }: { item: CourseType }) => {
    return (
      <li>
        <Link to={`/admin/courses/${item.course_id}`}>
          {item.title} ({item.status === 'active' ? 'Активен' : 'Не активен'})
        </Link>
      </li>
    )
  }

  return (
    <>
      <Header />
      <div className={'container'}>
        <h2>Панель администрирования - Список курсов</h2>
        <Link to={'/admin/courses/create'}>
          <button>Создать курс</button>
        </Link>
        <br />
        <br />
        {isFetching ? (
          <span>Загрузка курсов...</span>
        ) : (
          <ul>
            {courses.map(item => (
              <CourseItem key={item.course_id} item={item} />
            ))}
          </ul>
        )}
      </div>
      <Footer />
    </>
  )
}
